module.exports = __webpack_public_path__ + "img/Group 4071.e5f73ca8.png";